import vmClient from 'app/services/vmClient';
import { Entity, IEntityType, IEntity, EntityStringId } from 'app/types/entity';
import { Image, IImage } from 'app/constants/schemas/Image';
import { Text, IText } from 'app/constants/schemas/Text';
import { Language, LanguageMarshaller } from 'app/constants/enums/Language';

export interface IDialogSpeaker extends IEntity {
  attributes: {
    id: EntityStringId;
    name: string | null;
    nameTransliteration: string | null;
    language: Language;
    isRole: boolean | null;
    voiceGender: string | null;
    voiceLocale: string | null;
  };
  associations: {
    descriptionText: IText | null;
    image: IImage | null;
  };
}

export type DialogSpeaker = Entity<IDialogSpeaker>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DialogSpeaker: IEntityType<IDialogSpeaker> = vmClient.defineClass({
  typeName: 'DialogSpeaker',
  version: 4,
  lockable: true,
  persisted: true,
  attributes: {
    name: 'string',
    nameTransliteration: 'string',
    language: {
      type: Language,
      marshaller: LanguageMarshaller,
      notNull: true,
    },
    isRole: 'boolean',
    voiceGender: 'string',
    voiceLocale: 'string',
  },
  associations: {
    descriptionText: Text,
    image: Image,
  },
});
